export default {
  dashboardLoading: true,
  auth: {},
  filterCartera: {
    cod_agente: '',
    cod_tipo_agente: '',
    tableIndex: 0,
    tableName: 'Pólizas y Endosos',
    search: '',
    start: 0,
    length: 10,
    ramo: 0
  },
  ramos: [],
  productores: [],
  productoresComisionesRetenciones: [],
  organizadores: [],
  tiposDeEndoso: [],
  condicionesIva: ['CONSUMIDOR FINAL', 'EXENTO', 'INSCRIPTO', 'MONOTRIBUTISTA', 'NO CATEGORIZADO'],
  condicionesIIBB: ['CONSUMIDOR FINAL', 'EXENTO', 'INSCRIPTO', 'INSCRIPTO CONVENIO', 'INSCRIPTO LOCAL', 'NO INSCRIPTO'],
  condicionesGanancias: ['MONOTRIBUTISTA', 'INSCRIPTO', 'NO INSCRIPTO'],
  condicionesSS: ['PERS FIS - INSC', 'PERS JURID', 'PERS FIS - ALIC 50%', 'PERS JUR - ALIC 2%'],
  monedas: [],
  tiposCuenta: [],
  // dashboard
  filterVencimientos: {},
  vencimientos: 0,
  filterAdeudadas: {},
  adeudadas: 0,
  filterRefacturacionesRc: {},
  refacturacionesRc: 0,
  filterRefacturacionesPer: {},
  refacturacionesPer: 0,
  recursos: {
    categorias: [],
    posts: []
  },
  tipoBusqueda: '',
  menuProductor: []
};
